module.exports = __webpack_public_path__ + "img/btn_menu_jxs_c.da4408b1.png";